const SELECTORS = {
  FEATURED: {
    GALLERY: ".gallery-featured",
    THUMBS: ".gallery-featured-thumbs",
    THUMBS_PLACEHOLDERS: ".gallery-featured-thumbs .video-placeholder",
  },
  DESKTOP: {
    GALLERY: ".gallery-desktop",
    THUMBS: ".gallery-desktop-thumbs",
    THUMBS_PLACEHOLDERS: ".gallery-desktop-thumbs .video-placeholder",
  },
  MODAL: {
    TRIGGER: ".js-product-modal-trigger",
    TABS: ".product-modal__tab",
    CONTAINER: "#product-modal",
  },
};

document.addEventListener("DOMContentLoaded", initProductModal);

function initProductModal() {
  initModalTriggers();
}

function initModalTriggers() {
  const modalOpeners = document.querySelectorAll(SELECTORS.MODAL.TRIGGER);
  modalOpeners.forEach((trigger) => {
    trigger.addEventListener("click", handleModalOpen);
  });
}

function handleModalOpen(event) {
  const modal = document.querySelector(SELECTORS.MODAL.CONTAINER);
  modal.show(event.target);
  openTab(event.target.getAttribute("data-target"));
  initTabClicks();
}

function initSwiper(targetId) {
  const config = targetId === "#tab-1" ? SELECTORS.FEATURED : SELECTORS.DESKTOP;
  initGallerySwiper(config);
}

function initTabClicks() {
  const tabs = document.querySelectorAll(SELECTORS.MODAL.TABS);
  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const targetId = tab.getAttribute("data-target");
      openTab(targetId);
      initSwiper(targetId);
    });
  });
}

function openTab(targetTab) {
  const tabs = document.querySelectorAll(SELECTORS.MODAL.TABS);
  if (!tabs.length) return;
  stopAllVideos();

  tabs.forEach((tab) => {
    const isActiveTarget = tab.getAttribute("data-target") === targetTab;
    tab.classList.toggle("product-modal__tab--active", isActiveTarget);

    const contentSection = document.querySelector(
      tab.getAttribute("data-target")
    );
    if (contentSection) {
      contentSection.style.display = isActiveTarget ? "flex" : "none";
    }
  });
  initSwiper(targetTab);

  if (targetTab === "#tab-2") {
    updateDesktopImages(0);
  }
}

function initGallerySwiper(config) {
  const thumbsSwiper = new Swiper(config.THUMBS, {
    loop: false,
    spaceBetween: 10,
    slidesPerView: config === SELECTORS.FEATURED ? 2 : 4,
    // slidesPerGroup: 1,
    direction: "horizontal",
    // freeMode: true,
    watchOverflow: true,
    normalizeSlideIndex: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    on: {
      click: (swiper) => {
        if (config === SELECTORS.DESKTOP) {
          updateDesktopImages(swiper.clickedIndex);
        }
      },
      slideChange: () => {
        stopAllVideos();
      },
    },
    breakpoints: {
      320: {
        slidesPerView: config === SELECTORS.FEATURED ? 3 : 5,
        spaceBetween: 10,
        direction: "horizontal",
      },
      480: {
        slidesPerView: config === SELECTORS.DESKTOP ? 7 : 4,
        spaceBetween: 10,
        direction: "horizontal",
      },
      740: {
        slidesPerView: config === SELECTORS.FEATURED ? 5 : 8,
        direction: config === SELECTORS.FEATURED ? "vertical" : "horizontal",
      },
    },
  });

  new Swiper(config.GALLERY, {
    loop: false,
    spaceBetween: 10,
    watchOverflow: true,
    thumbs: {
      swiper: thumbsSwiper,
      multipleActiveThumbs: false,
    },
    on: {
      slideChange: stopAllVideos,
    },
  });
}

function updateDesktopImages(index) {
  const imageSets = document.querySelectorAll(".desktop-images-set");
  imageSets.forEach((set, i) => {
    set.style.display = i === index ? "flex" : "none";
  });
}

function stopAllVideos() {
  const videos = document.querySelectorAll(
    `${SELECTORS.FEATURED.GALLERY} video, ${SELECTORS.DESKTOP.GALLERY} video`
  );
  const iframes = document.querySelectorAll(
    `${SELECTORS.FEATURED.GALLERY} iframe, ${SELECTORS.DESKTOP.GALLERY} iframe`
  );
  if (iframes.length > 0) {
    iframes.forEach((iframe) => {
      iframe.contentWindow.postMessage(
        '{"event":"command","func":"pauseVideo","args":""}',
        "*"
      );
    });
  }
  if (videos.length > 0) {
    videos.forEach((video) => {
      video.pause();
      video.currentTime = 0;
    });
  }
}
